define('lib/mentionsinput/PodioMentionsInput',['require','underscore','jquery','lib/mentionsinput/MentionsInput','lib/Podio.Utils','lib/Podio.UI.AutoCompleter'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var MentionsInput = require('lib/mentionsinput/MentionsInput');
  var utils = require('lib/Podio.Utils');
  var AutoCompleter = require('lib/Podio.UI.AutoCompleter');

  // PodioMentionsInput
  function PodioMentionsInput(elmContainer, options) {
    // Apply default settings
    $.extend(true, options, {
      minChars: 0,
      autoCompleter: {
        initialize: function(elmWrapperBox, mentionsInput) {

          var self = this;
          var autoCompleter = new AutoCompleter(elmWrapperBox, {
            direction: mentionsInput.settings.autoCompleterDirection,
            useAbsolutePosition: _.isUndefined(mentionsInput.settings.autoCompleterAbsolutePosition) ? true : mentionsInput.settings.autoCompleterAbsolutePosition,
            enableTabKey: true,
            compensateForBottomMargin: !$('body').hasClass('calendar')
          });

          autoCompleter.signals.onItemSelected.add(function(item) {
            mentionsInput.addMention({
              value:  item.name,
              id:     item.id,
              type:   item.type
            });
          });

          return autoCompleter;
        },
        getSelectedItem : 'getActiveItemData',
        isVisible       : 'isVisible',
        populate        : 'populate',
        hide            : 'hide',
        loading         : 'renderLoading'
      }
    });

    MentionsInput.apply(this, _.toArray(arguments));

  }

  PodioMentionsInput.prototype = MentionsInput.prototype;

  return PodioMentionsInput;

});

